import { RegistroCadastro } from "./RegistroCadastro";

export class RegistroCadastroInsert {
  registroCadastro: RegistroCadastro[];
  IdIdentificadorCadastro: number;
}